import ATabNav from './index.vue';

ATabNav.install = app => {
  app.component(ATabNav.name, ATabNav);
};

export default ATabNav;
